<template>
  <div class="carousel carousel-slider">
    <a v-if="capa" class="carousel-item modal-trigger"  href="#modal1"  @click="AbrirModal(capa)">
      <img  class=" responsive-img" v-lazy="capa">
    </a>
    <a class="carousel-item modal-trigger"  href="#modal1" v-for="item in imagens" :key="item.id" @click="AbrirModal(item.galeria_imagem)">
      <img  class=" responsive-img" v-lazy="item.galeria_imagem">
    </a>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props:["capa"],
  data() {
    return {
      carousel: null,
      item: {id: 0, arquivo: ""},
      imagens: this.$store.state.produto.galerias
    };
  },
  methods: {
    AbrirModal(url) {
      this.$store.commit('imagem_zoom', url)
    }
  },
  mounted() {
    $(document).ready(function () {

      setTimeout(() => {
        $(".carousel.carousel-slider").carousel({
          fullWidth: true,
          indicators: true
        });
        $('.materialboxed').materialbox();
        $('.modal').modal();
      }, 500)

    });
  }
};
</script>

<style scoped>
@media only screen and (max-width : 450px) {
  .carousel {
    max-height: 200px;
  }
}

@media only screen and (min-width : 450px) {
  .carousel {
    max-height: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/Carousel.vue